import type { StackProps } from '@mui/material';
import { CustomizedAccordion } from '@rumblefish/ui/Rumblefish23Theme';
import parse from 'html-react-parser';

import { AccordionData, faqData } from './Faq.data';
import {
  MainText,
  GlowStack,
  StyledStack,
  DescriptionText,
  StyledTextStack,
  LatestFaqSection,
  StyledContentStack,
  StyledAccordionStack,
} from './styles';

export const Faq = ({ ...props }: StackProps): React.ReactElement => {
  return (
    <LatestFaqSection width="normal">
      <GlowStack />
      <StyledStack {...props}>
        <StyledContentStack>
          <StyledTextStack>
            <MainText variant="display_sm">{parse(faqData.mainText)}</MainText>
            <DescriptionText variant="strong_400">
              {faqData.description}
            </DescriptionText>
          </StyledTextStack>
          <StyledAccordionStack>
            <CustomizedAccordion data={AccordionData()} />
          </StyledAccordionStack>
        </StyledContentStack>
      </StyledStack>
    </LatestFaqSection>
  );
};
